module.exports = __webpack_public_path__ + "img/horizontal_2_1_r_7016.4b695108.png";